<div class="mainview">

<p-tabView>
  <p-tabPanel header="Volume adjustment" style="padding: 0em;">
    <div>
      <app-step-ngs-volume-adjustment></app-step-ngs-volume-adjustment>
    </div>
  </p-tabPanel> 

  <p-tabPanel header="Fragment Analysis" style="padding: 0em;">
    <div>
      <app-ngs-fragment-analysis></app-ngs-fragment-analysis>
    </div>
  </p-tabPanel>

</p-tabView>

</div>
